import { node } from '@/plugins/axios'

export const getSellers = async () => {
  try {
    const { data } = await node.get('/me/sellers', {
      params: { feed: 'stockCompare' }
    })
    return data
  } catch (err) {
    throw err
  }
}
